import { render } from "./TimePicker.vue?vue&type=template&id=13f23168"
import script from "./TimePicker.vue?vue&type=script&lang=ts"
export * from "./TimePicker.vue?vue&type=script&lang=ts"
script.render = render

export default script